// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__31io2","gfeWrapper":"CalendarEvent_gfeWrapper__2tTL5"};